module.exports = __webpack_public_path__ + "img/youtube.ec1efab4.png";